// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"f3552198","142":"4cd5c157","272":"7c7ddc76","292":"d1b99e4d","330":"a3f2b290","357":"756c2281","453":"b5d80ab2","789":"ea34aa5f","832":"a39a7b4c"}[chunkId] + ".chunk.js";
};